import { $$ } from "./util.js";

export function initFlip() {
  $$(".flip").forEach((b) =>
    b.addEventListener("click", () =>
      b.setAttribute("aria-pressed", b.getAttribute("aria-pressed") === "true" ? "false" : "true")
    )
  );
}
